import { selector } from '@/lib/selectors';
import { aggregationsSelector } from '@/domain/documents/documentSelector';
import type { SearchAggregations, SearchDoctype } from '@/domain/documents/schemas';

const EMPTY: SearchDoctype[] = [];

// The document-type tabs for the active workspace category, straight from the search_new
// `aggregations` block (fully backend-driven: id, name_id, label, count). These are the
// workspace-level doctype buckets over documents — NOT a single document's doctype. Empty
// until an aggregations-bearing fetch resolves (or when the feature is off).
export const workspaceDoctypesSelector = selector<unknown, SearchDoctype[]>(
  aggregationsSelector,
  (aggregations: SearchAggregations | null): SearchDoctype[] =>
    aggregations ? aggregations.tabs : EMPTY,
);
